// extracted by mini-css-extract-plugin
module.exports = {"small":"styles_small__yOi-F","wrapper":"styles_wrapper__ZHamZ","imageElement":"styles_imageElement__7Ybk-"};